import { apiRequest } from "../../../api/apiRequest";
import {
  DELETE_QUESTION_FROM_ASSIGNMENT,
  DELETE_QUIZ_ASSIGNMENT,
  GET_ALL_ASSESSMENT_DATA,
  GET_ASSIGNMENT_HISTORY,
  POST_CREATE_ALL_ASSIGNMENT_HISTORY,
  POST_CREATE_RESOURCE,
  POST_GENERATE_CAT_PAPER,
  POST_GENERATE_QUESTIONS,
  UPDATE_QUIZ_ASSIGNMENT,
} from "../../../utils/api";
import {
  CREATE_ALL_ASSIGNMENT_FAILURE,
  CREATE_ALL_ASSIGNMENT_SUCCESS,
  CREATE_ASSIGNMENT_FAILURE,
  CREATE_ASSIGNMENT_SUCCESS,
  CREATE_RESOURCE_FAILURE,
  CREATE_RESOURCE_SUCCESS,
  DELETE_QUIZ_FAILURE,
  DELETE_QUIZ_SUCCESS,
  GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
  GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS,
  HISTORY_ASSIGNMENT_FAILURE,
  HISTORY_ASSIGNMENT_SUCCESS,
} from "./resource.actionTypes";

export const createResource = (payLoad) => async (dispatch) => {
  const formData = new FormData();
  formData.append("file", payLoad.file);
  formData.append("subject", payLoad.subject);
  formData.append("chapter", payLoad.chapter);
  formData.append("subject_type", payLoad.subject_type);
  formData.append("grades", payLoad.grades);
  formData.append("division", payLoad.division);
  formData.append("board", payLoad.board);
  formData.append("medium", payLoad.medium);

  if (payLoad.cover_image !== null) {
    formData.append("cover_image", payLoad.cover_image);
  }

  // Note: no need to set Content-Type manually — axios/browser sets the
  // correct multipart boundary automatically when the body is FormData.
  const result = await apiRequest("post", POST_CREATE_RESOURCE, formData);

  if (result.success) {
    dispatch({
      type: CREATE_RESOURCE_SUCCESS,
      payload: result.data,
    });
    return result.data;
  } else {
    dispatch({
      type: CREATE_RESOURCE_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const generateAssignment = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_GENERATE_QUESTIONS, payLoad);

  if (result.success) {
    dispatch({
      type: GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS,
      payload: result.data,
    });
    return { success: true, data: result.data };
  }

  console.error("Unable to process request.", result.message);

  dispatch({
    type: GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
    payload: {
      message: result.message,
    },
  });

  return { success: false, message: result.message };
};

export const updateAssignment = (payLoad) => async (dispatch) => {
  const result = await apiRequest("patch", UPDATE_QUIZ_ASSIGNMENT, payLoad);

  if (result.success) {
    return { success: true };
  }

  console.error("Unable to process request.", result.message);

  // dispatch({
  //   type: GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
  //   payload: {
  //     message: result.message,
  //   },
  // });

  return { success: false, message: result.message };
};

export const assignmentHistory = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ASSIGNMENT_HISTORY);

  if (result.success) {
    dispatch({
      type: HISTORY_ASSIGNMENT_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: HISTORY_ASSIGNMENT_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const createAllAssignment = (payLoad) => async (dispatch) => {
  const result = await apiRequest(
    "post",
    POST_CREATE_ALL_ASSIGNMENT_HISTORY,
    payLoad
  );

  if (result.success) {
    dispatch({
      type: CREATE_ALL_ASSIGNMENT_SUCCESS,
      payload: result.data,
    });
    return { success: true, data: result.data };
  }

  console.error("Unable to process request.", result.message);

  dispatch({
    type: CREATE_ALL_ASSIGNMENT_FAILURE,
    payload: {
      message: result.message,
    },
  });

  return { success: false, message: result.message };
};

export const deleteQuizAssignment = (payLoad) => async (dispatch) => {
  const result = await apiRequest(
    "delete",
    DELETE_QUIZ_ASSIGNMENT,
    null,
    { data: payLoad }
  );

  if (result.success) {
    dispatch({
      type: DELETE_QUIZ_SUCCESS,
      payload: result.data,
    });
    return { success: true, data: result.data };
  }

  console.error("Unable to process request.", result.message);

  dispatch({
    type: DELETE_QUIZ_FAILURE,
    payload: { message: result.message },
  });

  return { success: false, message: result.message };
};

export const allAssignmentHistory = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ALL_ASSESSMENT_DATA);

  if (result.success) {
    dispatch({
      type: HISTORY_ASSIGNMENT_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: HISTORY_ASSIGNMENT_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const deleteQuestionFromAssignment = (payLoad) => async (dispatch) => {
  const result = await apiRequest(
    "delete",
    DELETE_QUESTION_FROM_ASSIGNMENT,
    null,
    { data: payLoad }
  );

  if (result.success) {
    return { success: true, data: result.data };
  }

  return { success: false, message: result.message };
};